import { Divider } from "antd";
import { MyHeader } from "Components/MyHeader/MyHeader";
import { MyText } from "Components/MyText/MyText";
import { MyTitle } from "Components/MyTitle/MyTitle";
import { defaultSettings } from "css/defaultAntStyles";
import React from "react";
export const CheckEndStep = ({ projectWorks, projectUsers, projectTitle }) => {
  return (
    <MyHeader mainTitle="Перевірте всі дані перед створенням проекту.">
      <Divider style={{ backgroundColor: defaultSettings.colorPrimary }} />
      <MyTitle level={5} text={`Назва проекту: ${projectTitle}`} />
      <Divider style={{ backgroundColor: defaultSettings.colorPrimary }} />
      <div style={{ marginBottom: 32 }}>
        <MyTitle level={5} text="Дозволені роботи" />

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          {projectWorks?.length ? (
            projectWorks.map((item) => (
              <div
                key={item.id}
                style={{
                  border: `2px solid ${defaultSettings.colorPrimary}`,
                  padding: "12px 16px",
                  borderRadius: 10,
                  minWidth: 220,
                }}
              >
                <MyText type="" strong>
                  {item?.title}
                </MyText>

                {item?.allowedWorkType?.plannedValue ? (
                  <div style={{ marginTop: 6 }}>
                    <MyText type="secondary">
                      {item.allowedWorkType.plannedValue} {item.unit}
                    </MyText>
                  </div>
                ) : null}
              </div>
            ))
          ) : (
            <MyText type="secondary">Немає робіт</MyText>
          )}
        </div>

        <Divider style={{ backgroundColor: defaultSettings.colorPrimary }} />

        <MyTitle level={5} text="Вибрані користувачі" />
        {Object.keys(projectUsers).length > 0 ? (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            {Object.values(projectUsers)
              .flat()
              .reduce((acc, el) => {
                const inArray = acc.some((elem) => elem.id === el.id);
                if (!inArray) {
                  acc.push(el);
                }

                return acc;
              }, [])
              .map((user) => (
                <div
                  key={user.id}
                  style={{
                    border: `2px solid ${defaultSettings.colorPrimary}`,
                    padding: "12px 16px",
                    borderRadius: 10,
                    minWidth: 220,
                  }}
                >
                  <MyText type="" strong>
                    {user.name}
                  </MyText>
                  <div>
                    <MyText type="secondary">{user.email}</MyText>
                  </div>
                </div>
              ))}
          </div>
        ) : (
          <MyText type="secondary">Немає вибраних користувачів</MyText>
        )}
      </div>
    </MyHeader>
  );
};
